import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Base from "components/Base";
import BaseListagem from "components/BaseListagem";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import ModalReabrirItemPedido from "components/modal/pedido/ModalReabrirItemPedido";
import ModalLigarOPsItemPedido from "components/modal/producao/ModalLigarOPsItemPedido";
import { useFilter } from "contexts/FilterContext";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Pageable from "model/page/Pageable";
import ItemPedido from "model/producao/ItemPedido";
import OrdemProducao from "model/producao/OrdemProducao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import GerarOpService from "service/producao/GerarOpService";
import PedidoService from "service/producao/PedidoService";
import { produtoCompleteMethod } from "utils/autocompleteUtils";
import { converterData } from "utils/convert";
import { dateRangeFilterTemplate, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, numberFilterTemplate, NumberMatchModeOptions, ProdutoFilterTemplate, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";

const gerarOpService = new GerarOpService();
const pedidoService = new PedidoService();

export default function GerarOP() {

    const { msgAlerta, msgSucesso, msgErro } = useToastContext();
    const [dialogGerar, setDialogGerar] = useState<{ data: ItemPedido | null, visible: boolean }>({ data: null, visible: false });

    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<ItemPedido[]>([]);
    const [pageable, setPageable] = useState(new Pageable(0, 10, "pedido.numeroPedido,DESC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);

    const [dialogGerarSemPedido, setDialogGerarSemPedido] = useState<{ data: OrdemProducao | null, visible: boolean }>({ data: null, visible: false });
    const [modalReabrirItem, setModalReabrirItem] = useState<{ visible: boolean }>({ visible: false });
    const [modalLigarOPsItem, setModalLigarOPsItem] = useState<{ visible: boolean}>({ visible: false});
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);

    const [clientes, setClientes] = useState<Pessoa[]>([]);

    const defaultFilters: DataTableFilterMeta = {
        numeroPedido: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        sequencial: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produtoNome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidade: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    };

    const filterContext = useFilter();
    const screen = "gerarOp";
    const [filters, setFilters] = useState<DataTableFilterMeta>(filterContext.filters[screen] ? filterContext.filters[screen] : defaultFilters);

    const clienteFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={clientes}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    useEffect(() => {
        setFiltrando(true);
        gerarOpService.getProdutosProduzidos().then((produtos) => {
            setProdutos(produtos);
        }).catch((err) => {
            console.log(err);
        });
        pedidoService.clientes().then((clientes) => {
            setClientes(clientes);
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    useEffect(() => {
        setFiltrando(true);
    }, [filters]);

    useEffect(() => {
        if (filtrando) {
            filterContext.updateFilters(screen, filters);
            gerarOpService
                .pesquisar(pageable, filters)
                .then(lista => {
                    setFiltrando(false);
                    setRows(lista.content);
                    setTotalElements(lista.totalElements);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }
    }, [filtrando, pageable]);

    const onPage = (event: DataTableStateEvent) => {

        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setFiltrando(true);

    };

    const gerarOps = (item: ItemPedido) => {
        gerarOpService.gerarOps(item).then((op) => {
            msgSucesso("OP(s) gerada(s)", "OP(s) gerada(s) com sucesso!");
            setFiltrando(true);
            setDialogGerar({ data: null, visible: false });
        }).catch((err) => {
            console.log(err)
            if (err && err.data && err.data.message) {
                msgAlerta("Atenção", err.data.message);
            } else {
                msgErro("Erro", "Erro ao gerar OP");
            }
        });
    }

    const headerDialogTable = <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
        <div></div>
        <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Ordens de produção</span>
        <div >
            <Button
                style={{}}
                type="button" icon={<FontAwesomeIcon icon="add" />}
                className="ui-button-info"
                onClick={() => addOP()}
            ></Button>
        </div>
    </div>

    function addOP() {
        if (dialogGerar.data) {
            let op: OrdemProducao = new OrdemProducao();
            op.produto = dialogGerar.data.produto;
            op.itemPedido = { ...dialogGerar.data, ordensProducao: [] };
            if (dialogGerar.data.ordensProducao == null) {
                dialogGerar.data.ordensProducao = [];
            }
            dialogGerar.data.ordensProducao.push(op);
        }
    }

    function removerOp(op: OrdemProducao, options: any) {
        if (dialogGerar.data) {
            dialogGerar.data.ordensProducao = dialogGerar.data.ordensProducao.filter((item, index) => index !== options.rowIndex);
            setDialogGerar({ ...dialogGerar });
        }
    }

    const editorQuantidade = (rowData: any) =>
        <InputNumber
            disabled={rowData.id}
            value={rowData.qtPrevista}
            minFractionDigits={1}
            maxFractionDigits={8}
            maxLength={12}
            locale="pt-BR"
            useGrouping={false}
            onChange={(e) => {
                rowData.qtPrevista = e.value as number;
                if (dialogGerar.data) {
                    if ((dialogGerar.data?.ordensProducao.reduce((acc, op) => acc + op.qtPrevista, 0) || 0) >= dialogGerar.data?.qtPedida) {
                        dialogGerar.data.status = "FECHADO";
                    } else {
                        dialogGerar.data.status = "ABERTO";
                    }
                }
                setDialogGerar({ ...dialogGerar });
            }}
            style={{ width: '100%' }} />;

    const footer = <div>
        <Button label="Gerar OP(s)" icon="pi pi-check" onClick={() => gerarOps(dialogGerar.data as ItemPedido)} />
        <Button label="Cancelar" icon="pi pi-times" onClick={() => setDialogGerar({ data: null, visible: false })} />
    </div>

    const header = <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
        <div></div>
        <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Gerar OP</span>

        <div style={{ display: "flex" }}>

            <Button
                style={{ marginRight: '5px' }}
                type="button"
                label="Ligar OPs em itens"
                className="ui-button-info"
                onClick={() => setModalLigarOPsItem({ visible: true })}
            ></Button>

            <Button
                style={{ marginRight: '5px' }}
                type="button"
                label="Reabrir item de pedido"
                className="ui-button-info"
                onClick={() => setModalReabrirItem({ visible: true })}
            ></Button>

            <Button
                style={{}}
                type="button" icon={<FontAwesomeIcon icon="add" />}
                label="Gerar OP sem pedido"
                className="ui-button-info"
                onClick={() => setDialogGerarSemPedido({ data: new OrdemProducao(), visible: true })}
            ></Button>
        </div>
    </div>


    const footerSemPedido = <div>
        <Button label="Gerar OP(s)" icon="pi pi-check" onClick={() => gerarOpSemPedido(dialogGerarSemPedido.data as OrdemProducao)} />
        <Button label="Cancelar" icon="pi pi-times" onClick={() => setDialogGerarSemPedido({ data: null, visible: false })} />
    </div>

    const gerarOpSemPedido = (op: OrdemProducao) => {
        if (!podeGerarOpSemPedido(op)) {
            return;
        }
        op.itemPedido = null;
        gerarOpService.gerarOp(op).then((op) => {
            msgSucesso("OP gerada", "OP gerada com sucesso!");
            setFiltrando(true);
            setDialogGerarSemPedido({ data: null, visible: false });
        }).catch((err) => {
            console.log(err)
            if (err && err.data && err.data.message) {
                msgAlerta("Atenção", err.data.message);
            } else {
                msgErro("Erro", "Erro ao gerar OP");
            }
        });
    }

    function podeGerarOpSemPedido(op: OrdemProducao) {
        if (op.produto == null || op.produto.codigo == null) {
            msgAlerta("Atenção", "Informe o produto");
            return false;
        }
        if (op.qtPrevista == null || op.qtPrevista <= 0) {
            msgAlerta("Atenção", "Informe a quantidade prevista");
            return false;
        }
        return true;
    }

    return (
        <Base tituloPagina="Gerar OP" >
            {modalLigarOPsItem.visible && <ModalLigarOPsItemPedido visible={modalLigarOPsItem.visible}
                onHide={() => {
                    setModalLigarOPsItem({ visible: false });
                    setFiltrando(true);
                }} />}
            {modalReabrirItem.visible && <ModalReabrirItemPedido visible={modalReabrirItem.visible}
                onHide={() => {
                    setModalReabrirItem({ visible: false });
                    setFiltrando(true);
                }} />}
            <Dialog visible={dialogGerar.visible} onHide={() => setDialogGerar({ data: null, visible: false })} header={"Gerar Ops"} footer={footer} style={{ width: '45vw', height: '50vh' }} >
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                    <DataTable value={dialogGerar.data?.ordensProducao} header={headerDialogTable} emptyMessage="Nenhum registro encontrado">
                        <Column field="qtPrevista" header="Quantidade Prevista" body={editorQuantidade} />
                        <Column style={{ width: "75px" }} body={(rowData: OrdemProducao, options) => <Button disabled={rowData.id != 0} type="button" icon={<FontAwesomeIcon icon="remove" />} className="ui-button-danger" style={{ marginLeft: 8 }} onClick={() => removerOp(rowData, options)}></Button>} />
                    </DataTable>

                    <div style={{ display: "flex", alignContent: "center" }}>
                        <Checkbox inputId="cbFecharPedido" checked={dialogGerar.data?.status == "FECHADO"} onChange={(e) => {
                            setDialogGerar({ ...dialogGerar, data: { ...dialogGerar.data, status: e.checked ? "FECHADO" : "ABERTO" } as ItemPedido })
                        }} />
                        <label style={{ marginLeft: 4, fontWeight: 700 }}>Fechar item?</label>
                    </div>

                </div>
            </Dialog>
            <Dialog visible={dialogGerarSemPedido.visible} onHide={() => setDialogGerarSemPedido({ data: null, visible: false })} header={"Gerar Op Sem pedido"} footer={footerSemPedido}  >
                <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <Label obrigatorio>Produto</Label>
                    <AutoComplete
                        value={dialogGerarSemPedido.data?.produto}
                        field="nome"
                        dropdown
                        style={{ width: 500 }}
                        inputStyle={{ width: "100%" }}
                        suggestions={produtosFiltrados}
                        completeMethod={(e) => setProdutosFiltrados(produtoCompleteMethod(produtos, e.query))}
                        onChange={(e) => {
                            if (typeof e.target.value == "string") {
                                let prod = new Produto();
                                prod.nome = e.target.value;
                                setDialogGerarSemPedido({ ...dialogGerarSemPedido, data: { ...dialogGerarSemPedido.data as OrdemProducao, produto: prod } })
                            } else {
                                setDialogGerarSemPedido({ ...dialogGerarSemPedido, data: { ...dialogGerarSemPedido.data as OrdemProducao, produto: e.target.value } })
                            }
                        }}
                        placeholder="Produto"
                    />

                    <Label obrigatorio>Quantidade prevista</Label>
                    <InputNumber
                        value={dialogGerarSemPedido.data?.qtPrevista}
                        style={{ width: 500 }}
                        inputStyle={{ width: "100%" }}
                        minFractionDigits={1}
                        maxFractionDigits={8}
                        maxLength={12}
                        locale="pt-BR"
                        useGrouping={false}
                        onChange={(e) => setDialogGerarSemPedido({ ...dialogGerarSemPedido, data: { ...dialogGerarSemPedido.data as OrdemProducao, qtPrevista: e.value as number } })}
                    />

                </div>
            </Dialog>
            <DataTable
                header={header}
                value={rows} lazy dataKey="id" paginator
                first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                loading={filtrando} tableStyle={{ minWidth: '75rem' }}
                filters={filters} onFilter={(e) => setFilters(e.filters)}
                emptyMessage="Nenhum registro encontrado"
            >
                <Column field="pedido.numeroPedido" header="Pedido" filter filterField="numeroPedido" showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="sequencial" header="Sequência" filter showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="produto.codigo" header="Cód. Produto" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} />

                <Column field="produto.nome" header="Nome Produto" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterField="produtoNome" />

                <Column field="pedido.cliente.nome" header="Cliente" filter showFilterOperator={false} showAddButton={false} filterField="cliente"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={clienteFilterTemplate} />

                <Column field="qtPedida" header="Quantidade" filter filterField="quantidade" showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column header="Qtd. Gerada" body={(rowData: ItemPedido) => rowData.ordensProducao.reduce((acc, op) => op.id ? acc + op.qtPrevista : acc, 0)} />

                <Column header="Data geração" body={(rowData: ItemPedido) => converterData(rowData.pedido?.dataHoraGeracao)} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataGeracao"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />

                <Column field="status" header="Status" body={(rowData) => pedidoService.getStatusItem(rowData.status)} />

                <Column body={(rowData: ItemPedido) => {
                    return (
                        <div>
                            <Button className="btn btn-primary" onClick={() => setDialogGerar({ visible: true, data: rowData })}>Gerar OP(s)</Button>
                        </div>
                    )
                }} />
            </DataTable>
        </Base>

    )


}